import {
  ChevronRightIcon,
  Cog6ToothIcon,
  EllipsisHorizontalIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { CaretSortIcon, CheckIcon } from "@radix-ui/react-icons";
import { ObjectID } from "bson";
import clsx from "clsx";
import { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  useCreateKeyMomentCondition,
  useDeleteKeyMomentCondition,
  useGetKeyMoments,
} from "src/api/key-moments/key-moments";
import {
  JourneyTemplateData,
  KeyMomentWithConditionData,
} from "src/api/Services/Journeys/journeys";
import {
  TaskTemplateData,
  useGetTaskTemplates,
} from "src/api/Services/Journeys/journeyTemplates";
import {
  useGetJourneyTemplate,
  useGetStageAndTaskTemplatesList,
  useUpdateJourneyTemplate,
} from "src/api/Services/Tasks/journeys";
import { useGetSpace } from "src/api/Spaces/spaces";
import { useSnackBar } from "src/components/Reusable/CustomSnackbarProvider";
import { Button } from "src/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/components/ui/command";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import InputHeading from "src/components/ui/Headings/InputHeading";
import { Loading } from "src/components/ui/loading";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/ui/tabs";
import { SpaceNameAndSymbol } from "src/pages/spaces/spaces";
import { cn } from "src/utils/ui/ui";
import JourneyTemplateEdit from "./JourneyTemplateEdit";
import { JourneyTemplateContextProvider } from "./Template/TemplateEdit/Stages/JourneyTemplateContextProvider";

const JourneyTemplate = () => {
  const navigate = useNavigate();
  let { journeyTemplateId } = useParams();

  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const [value, setValue] = useState(tab === "analytics" ? 1 : 0);
  const { journeyTemplate } = useGetJourneyTemplate(String(journeyTemplateId));

  const [selectedIndex, setSelectedIndex] = useState(0);

  // const tabs: TabsProps["tabs"] = [
  //   {
  //     name: "Builder",
  //     panel: (

  //     ),
  //     id: "template",
  //   },
  //   // {
  //   //   name: "Analytics",
  //   //   panel: <JourneyTemplateAnalytics />,
  //   //   id: "analytics",
  //   // },
  //   {
  //     name: "Settings",
  //     panel: <TemplateSettings />,
  //     id: "settings",
  //   },
  // ];

  return (
    // <Container maxWidth="xl">
    <div className="flex h-full flex-col space-y-2 overflow-y-auto">
      <div className="h-12 items-center justify-between space-y-2 border-b border-gray-200/[.65] px-8 sm:flex sm:space-y-0">
        <div className="flex items-center space-x-2 text-sm">
          {journeyTemplate?.spaceId && (
            <SpaceSymbol spaceId={journeyTemplate.spaceId?.toString()} />
          )}
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <Link to={`/spaces/${journeyTemplate?.spaceId}/templates`}>
            <div className="text-gray-800">{"Templates"}</div>
          </Link>
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <Link to={`/spaces/${journeyTemplate?.spaceId}/templates/projects`}>
            <div className="text-gray-800">{"Projects"}</div>
          </Link>
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <div className="cursor-default text-gray-800">
            {journeyTemplate?.name}
          </div>
        </div>
        <Button
          variant={"ghost"}
          onClick={() => {
            navigate(`/templates/projects/${journeyTemplateId}/settings`);
          }}
          size="icon"
        >
          <Cog6ToothIcon className="h-4 w-4" />
        </Button>
      </div>

      {/* <div className="px-8">
        <Breadcrumbs
          breadcrumbs={[
            { title: "Project Templates", route: "/templates/projects" },
            {
              title: !!journeyTemplate ? journeyTemplate.name : "",
            },
          ]}
        />
        <div className="items-start justify-between space-y-2 sm:flex sm:space-y-0">
          <EditablePageHeading journeyTemplate={journeyTemplate} />
        </div>
      </div> */}
      <Tabs
        defaultValue="tasks"
        className="flex flex-1 flex-col overflow-y-auto pt-1"
      >
        <TabsList className="border-gray-200/70 px-8">
          <TabsTrigger className="font-normal" value="tasks">
            <span>Tasks</span>
          </TabsTrigger>
          {/* <TabsTrigger className="font-normal" value="analytics">
            <span>Analytics</span>
          </TabsTrigger> */}
          {/* <TabsTrigger className="font-normal" value="settings">
            <span>Settings</span>
          </TabsTrigger> */}
        </TabsList>
        <div className="flex-1 overflow-auto">
          <TabsContent value="tasks" className="h-full overflow-auto">
            <JourneyTemplateContextProvider showSubTasks={true}>
              {!!journeyTemplate && (
                <JourneyTemplateEdit journeyTemplate={journeyTemplate} />
              )}
            </JourneyTemplateContextProvider>
          </TabsContent>
          <TabsContent value="analytics" className="h-full overflow-auto">
            <Analytics />
          </TabsContent>
          {/* <TabsContent value="settings" className="h-full overflow-auto">
            <TemplateSettings />
          </TabsContent> */}
        </div>
      </Tabs>
      {/* <Tab.Group
          selectedIndex={selectedIndex}
          onChange={(index) => {
            setSelectedIndex(index);
          }}
          manual
        >
          <div className="px-8">
            <div className="border-b border-gray-200">
              <Tab.List className="-mb-px flex space-x-10">
                {tabs.map((t) => (
                  <Tab
                    className={({ selected }) =>
                      classNames(
                        "flex whitespace-nowrap border-b-2 py-4 text-sm font-medium focus-visible:outline-none",
                        selected
                          ? "border-primary-main text-primary-main"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      )
                    }
                    key={t.id}
                  >
                    {({ selected }) => (
                      <>
                        {t.name}
                        {t.count ? (
                          <span
                            className={classNames(
                              selected
                                ? "bg-primary-100 text-primary-600"
                                : "bg-gray-100 text-gray-900",
                              "ml-3 hidden rounded-full py-0.5 px-2.5 text-xs font-medium md:inline-block"
                            )}
                          >
                            {t.count}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Tab>
                ))}
              </Tab.List>
            </div>
          </div>
          <Tab.Panels className={"flex flex-1 flex-col overflow-auto px-3"}>
            {tabs.map((t) => (
              <Tab.Panel
                className={
                  "flex flex-1 flex-col overflow-y-auto focus:outline-none"
                }
                key={t.id}
              >
                {t.panel}
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group> */}
    </div>
    // <Grid
    //   container
    //   alignItems="center"
    //   justifyContent={"center"}
    //   spacing={3}
    //   paddingX={3}
    // >
    //   <Grid item xs={12}>
    //     <Back
    //       onClick={() => {
    //         navigate({
    //           pathname: `/journeys`,
    //           search: createSearchParams({
    //             tab: "templates",
    //           }).toString(),
    //         });
    //       }}
    //       backText={"Back to Templates"}
    //     />
    //   </Grid>
    //   <Grid item xs={12}>
    //     <Box sx={{ width: "100%" }}>
    //       <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    //         <Tabs
    //           value={value}
    //           onChange={handleChange}
    //           aria-label="basic tabs example"
    //         >
    //           <Tab sx={{ minWidth: tabWidth }} label="Template" />
    //           <Tab sx={{ minWidth: tabWidth }} label="Analytics" />
    //           <Tab sx={{ minWidth: tabWidth }} label="Settings" />
    //         </Tabs>
    //       </Box>
    //       <TabPanel value={value} index={0}>
    //         <JourneyTemplateEdit />
    //       </TabPanel>
    //       <TabPanel value={value} index={1}>
    //         <JourneyTemplateAnalytics />
    //       </TabPanel>
    //       <TabPanel value={value} index={2}>
    //         <TemplateTriggers />
    //       </TabPanel>
    //     </Box>
    //   </Grid>
    // </Grid>
    // </Container>
  );
};

export default JourneyTemplate;

export function SpaceSymbol({ spaceId }: { spaceId: string }) {
  const { data: space } = useGetSpace(spaceId);
  return (
    <>{space && <SpaceNameAndSymbol color={space.color} name={space.name} />}</>
  );
}

function EditablePageHeading({
  journeyTemplate,
}: {
  journeyTemplate: JourneyTemplateData | undefined;
}) {
  const [heading, setHeading] = useState(journeyTemplate?.name ?? "");
  const updateJourneyTemplateMutation = useUpdateJourneyTemplate();

  useEffect(() => {
    setHeading(journeyTemplate?.name ?? "");
  }, [journeyTemplate]);

  return (
    <>
      {!!journeyTemplate ? (
        <div className="mt-2 flex-1">
          <input
            className="w-full max-w-xl border-b-2 border-transparent text-2xl font-medium leading-7
            tracking-tight text-gray-900 outline-none hover:border-primary-main focus:border-primary-main focus:outline-none focus:ring-0"
            value={heading}
            onChange={(e) => {
              setHeading(e.target.value);
            }}
            onBlur={() => {
              if (
                !!journeyTemplate &&
                heading.trim() !== journeyTemplate.name &&
                journeyTemplate._id
              ) {
                updateJourneyTemplateMutation.mutate({
                  params: { _id: journeyTemplate._id, name: heading },
                  journeyTemplateId: journeyTemplate?._id,
                });
              }
            }}
          />
        </div>
      ) : (
        <div className="mt-2 h-8 w-40 rounded bg-gray-200" />
      )}
    </>
  );
}

function Analytics() {
  const { journeyTemplateId } = useParams();
  // const { data: taskTemplates } = useGetTaskTemplates(new ObjectID(journeyTemplateId))
  // console.log(taskTemplates)
  // console.log(taskTemplates)
  const { journeyTemplate } = useGetJourneyTemplate(String(journeyTemplateId));
  console.log(journeyTemplate?.keyMoments);
  const { data: taskTemplates } = useGetTaskTemplates(
    new ObjectID(journeyTemplateId)
  );
  const { stageAndTaskTemplateList } = useGetStageAndTaskTemplatesList(
    new ObjectID(journeyTemplateId)
  );
  console.log(taskTemplates);
  const { data: keyMoments } = useGetKeyMoments();
  const [open, setOpen] = useState(false);
  const [keyMoment, setKeyMoment] = useState<string | undefined>(undefined);
  const [statusTo, setStatusTo] = useState<string>("completed");
  const createKeyMomentConditionMutation = useCreateKeyMomentCondition();
  const [taskTemplateId, setTaskTemplateId] = useState<string | undefined>(
    undefined
  );
  const [triggerObject, setTriggerObject] = useState<"task" | "stage">("task");
  const [taskTemplateOpen, setTaskTemplateOpen] = useState(false);
  const snackbarCtx = useSnackBar();

  useEffect(() => {
    if (createKeyMomentConditionMutation.isSuccess) {
      setOpen(false);
    }
  }, [createKeyMomentConditionMutation.isSuccess]);

  return (
    <div className="flex h-full flex-col bg-light-background">
      <div className="mx-auto w-full max-w-3xl pt-20">
        <div className="space-y-1.5 border-gray-200/70 pb-2">
          <div className="text-xl font-medium">Key Moment Triggers</div>
          <div className="text-sm font-light text-gray-600">
            Define the triggers that should lead to the capturing of a key
            moment
          </div>
        </div>
        {!!journeyTemplate ? (
          <>
            <div className="mt-6">
              <div className="mt-6 space-y-6">
              {!!journeyTemplate?.keyMoments?.length && (
                <div className="flex justify-start">
                <Button
                  variant={"secondary"}
                  onClick={() => setOpen(true)}
                >
                  Add Key Moment Trigger
                </Button>
              </div>
              )}
                <div className="rounded-lg border border-gray-200 bg-white p-6 px-7 pb-4 shadow-sm">
                  {!!journeyTemplate?.keyMoments?.length && (
                    <>
                      <div className="flex items-center gap-6 border-b border-gray-200/70 pb-3 text-sm font-normal text-gray-500">
                        <div className="w-60 leading-none">Key Moment</div>
                        <div className="flex-1">Trigger</div>
                        <div className="w-16" />
                      </div>
                      {/* {keyMoments?.map((keyMoment) => (
                        <KeyMomentRow
                          key={keyMoment._id}
                          keyMoment={keyMoment}
                        />
                      ))} */}
                      {journeyTemplate?.keyMoments?.map((keyMoment, index) => (
                        <KeyMomentTriggerRow
                          taskTemplates={taskTemplates ?? []}
                          key={keyMoment._id.toString()}
                          keyMoment={keyMoment}
                          isLast={
                            !!journeyTemplate?.keyMoments?.length &&
                            index === journeyTemplate?.keyMoments?.length - 1
                          }
                        />
                      ))}
                    </>
                  )}
                  {!journeyTemplate?.keyMoments?.length && (
                    <div className="w-[420px] py-6 pb-8 px-6">
                      <div className="text-base font-medium">
                        No Key Moment Triggers
                      </div>
                      <div className="pt-4 text-sm font-light leading-relaxed text-gray-700">
                        There are currently no triggers defined to record key
                        moments. To learn more about key moments, click here.
                      </div>
                      <div className="flex space-x-2.5 pt-7">
                        <Button
                          variant={"secondary"}
                          onClick={() => setOpen(true)}
                        >
                          Add Key Moment Trigger
                        </Button>
                      </div>
                    </div>
                    // <div className="space-y-4 pb-2">
                    //   <div className="text-sm">
                    //     No key moment triggers created.
                    //   </div>
                    // <Button
                    //   variant={"secondary"}
                    //   onClick={() => setOpen(true)}
                    // >
                    //   Add Key Moment Trigger
                    // </Button>
                    // </div>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <Loading className="mt-20" />
        )}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl">
          <DialogHeader>
            <DialogTitle>New Key Moment Trigger</DialogTitle>
            <DialogDescription>
              Select the key moment and the trigger for when it should be
              captured
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-6 py-4">
            <div className="space-y-1">
              <InputHeading heading="Key Moment" required />
              <Select value={keyMoment} onValueChange={setKeyMoment}>
                <SelectTrigger className="h-9 w-72">
                  {keyMoment ? (
                    <SelectValue />
                  ) : (
                    <div className="text-gray-300">Select a key moment</div>
                  )}
                </SelectTrigger>
                <SelectContent>
                  {keyMoments?.map((keyMoment) => (
                    <SelectItem key={keyMoment._id} value={keyMoment._id}>
                      {keyMoment.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1">
              <InputHeading heading="Trigger" />
              <div className="flex items-center gap-1.5">
                {/* <div className="text-sm">Task</div> */}
                <Select
                  value={triggerObject}
                  onValueChange={(value) =>
                    setTriggerObject(value as "task" | "stage")
                  }
                >
                  <SelectTrigger className="h-9 w-fit">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="task">Task</SelectItem>
                    {/* <SelectItem value="stage">
                      Stage
                    </SelectItem> */}
                  </SelectContent>
                </Select>

                <Popover
                  open={taskTemplateOpen}
                  onOpenChange={setTaskTemplateOpen}
                  modal={true}
                >
                  <PopoverTrigger asChild>
                    <Button
                      variant="secondary"
                      role="combobox"
                      aria-expanded={open}
                      className="h-9 min-w-[120px] max-w-[320px] space-x-1.5 truncate font-normal"
                    >
                      <div
                        className={clsx(
                          "min-w-0 truncate",
                          taskTemplateId ? "" : "text-gray-300"
                        )}
                      >
                        {taskTemplateId
                          ? taskTemplates?.find(
                              (taskTemplate) =>
                                taskTemplate._id?.toString() === taskTemplateId
                            )?.title
                          : "Select a task"}
                      </div>
                      <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  {/* <PopoverContent
            className="pointer-events-auto w-fit min-w-[200px] max-w-[700px] p-0"
            align="end"
          >
            <Command
              filter={(value, search) => {
                return stageAndTaskTemplateList.taskTemplates
                  .find((t) => t._id.toString() === value)
                  ?.name.toLowerCase()
                  .includes(search.toLowerCase())
                  ? 1
                  : 0;
              }}
            >
              <CommandInput placeholder="Search taskk..." className="h-9" />
              <CommandList>
                <CommandEmpty>No task found.</CommandEmpty>
                {stageAndTaskTemplateList.stageTemplates.map((s) => (
                  <CommandGroup heading={s.name}>
                    {stageAndTaskTemplateList.taskTemplates
                      .filter(
                        (t) =>
                          t.journeyStageTemplate._id.toString() ===
                          s._id.toString()
                      )
                      .map((tt) => (
                        <CommandItem
                                key={tt._id.toString()}
                                value={tt._id.toString()}
                                className="gap-2"
                              >
                                <span className="truncate">{tt.name}</span>
                              </CommandItem>
                      ))}
                  </CommandGroup>
                ))}
              </CommandList>
            </Command>
          </PopoverContent> */}

                  <PopoverContent
                    // animateOut={false}
                    className="pointer-events-auto w-fit min-w-[200px] max-w-[700px] p-0"
                    align="start"
                  >
                    <Command
                      filter={(value, search) => {
                        return stageAndTaskTemplateList.taskTemplates
                          .find((t) => t._id.toString() === value)
                          ?.name.toLowerCase()
                          .includes(search.toLowerCase())
                          ? 1
                          : 0;
                      }}
                    >
                      <CommandInput
                        placeholder="Search task..."
                        className="h-9"
                      />
                      <CommandList>
                        <CommandEmpty>No task found.</CommandEmpty>
                        {stageAndTaskTemplateList.stageTemplates.map((s) => (
                          <CommandGroup heading={s.name}>
                            {stageAndTaskTemplateList.taskTemplates
                              .filter(
                                (t) =>
                                  t.journeyStageTemplate._id.toString() ===
                                  s._id.toString()
                              )
                              // .sort((a,b) => a.journeyStageTemplate.)
                              .map((taskTemplate) => (
                                <CommandItem
                                  key={taskTemplate._id.toString()}
                                  value={taskTemplate._id.toString()}
                                  onSelect={() => {
                                    setTaskTemplateId(
                                      taskTemplate._id.toString()
                                    );
                                    setTaskTemplateOpen(false);
                                  }}
                                  className="gap-2"
                                >
                                  <span className="truncate">
                                    {taskTemplate.name}
                                  </span>
                                  <CheckIcon
                                    className={cn(
                                      "ml-auto h-4 w-4 shrink-0",
                                      taskTemplateId ===
                                        taskTemplate._id.toString()
                                        ? "opacity-100"
                                        : "opacity-0"
                                    )}
                                  />
                                </CommandItem>
                                // <TooltipProvider delayDuration={1200}>
                                //   <Tooltip>
                                //     <TooltipTrigger asChild>

                                //     </TooltipTrigger>
                                //     <TooltipContent
                                //       align="start"
                                //       side="left"
                                //       sideOffset={12}
                                //     >
                                //       <p>{taskTemplate.journeyStageTemplate.name}</p>
                                //     </TooltipContent>
                                //   </Tooltip>
                                // </TooltipProvider>
                              ))}
                          </CommandGroup>
                        ))}
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
                <Select value={"status-change-to"}>
                  <SelectTrigger className="h-9 w-fit">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="status-change-to">
                      status changes to
                    </SelectItem>
                  </SelectContent>
                </Select>
                <Select value={statusTo} onValueChange={setStatusTo}>
                  <SelectTrigger className="h-9 w-fit">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="completed">
                      <div className="flex items-center">
                        <div className="flex items-center space-x-1">
                          <div
                            className={clsx(
                              "flex h-4 w-4 items-center justify-center rounded-full bg-green-500 text-white transition-all"
                            )}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={3}
                              stroke="currentColor"
                              className="h-3 w-3"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </div>
                        </div>
                        <span className="ml-2 font-medium">Completed</span>
                      </div>
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button onClick={() => setOpen(false)} variant={"secondary"}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                const existingTaskTemplatesWithKeyMoments =
                  journeyTemplate?.keyMoments?.map(
                    (keyMoment) =>
                      keyMoment.condition.filters.find(
                        (filter) => filter.field === "taskTemplateId"
                      )?.value
                  );
                if (
                  existingTaskTemplatesWithKeyMoments?.includes(taskTemplateId)
                ) {
                  snackbarCtx.showSnackbar(
                    "This task already has a key moment linked to it",
                    "error"
                  );
                  return;
                }
                const existingKeyMoments = journeyTemplate?.keyMoments?.map(
                  (keyMoment) => keyMoment._id.toString()
                );
                if (existingKeyMoments?.includes(String(keyMoment))) {
                  snackbarCtx.showSnackbar(
                    "This key moment is already linked to another trigger in the project template",
                    "error"
                  );
                  return;
                }
                if (keyMoment && taskTemplateId) {
                  createKeyMomentConditionMutation.mutate({
                    keyMomentId: keyMoment,
                    condition: {
                      event: "task status changed",
                      filters: [
                        {
                          field: "newStatus",
                          comparator: "eq",
                          value: "Completed",
                        },
                        {
                          field: "taskTemplateId",
                          comparator: "eq",
                          value: taskTemplateId,
                        },
                      ],
                    },
                  });
                }
              }}
              disabled={
                createKeyMomentConditionMutation.isLoading ||
                !taskTemplateId ||
                !keyMoment
              }
              variant={"default"}
            >
              {createKeyMomentConditionMutation.isLoading
                ? "Creating..."
                : "Create"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* <div className="px-8 border-b border-gray-200/70 h-14 flex items-center"><Button variant={"secondary"}>Add Key Moment Trigger</Button></div> */}
    </div>
  );
}

function KeyMomentTriggerRow({
  taskTemplates,
  keyMoment,
  isLast,
}: {
  taskTemplates: TaskTemplateData[];
  keyMoment: KeyMomentWithConditionData;
  isLast: boolean;
}) {
  const taskTemplateId = keyMoment.condition.filters.find(
    (filter) => filter.field === "taskTemplateId"
  )?.value;
  const taskTemplate = taskTemplates.find(
    (taskTemplate) => taskTemplate._id?.toString() === taskTemplateId
  );
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const deleteKeyMomentConditionMutation = useDeleteKeyMomentCondition();

  useEffect(() => {
    if (deleteKeyMomentConditionMutation.isSuccess) {
      setIsDeleting(false);
    }
  }, [deleteKeyMomentConditionMutation.isSuccess]);
  return (
    <div
      id={keyMoment._id.toString()}
      className={clsx(
        isLast ? "" : "border-b border-gray-200/70",
        "flex items-center gap-6 py-2.5 font-light text-gray-600"
      )}
    >
      {/* <div className="font-medium">{keyMoment.name}</div> */}
      <div className="w-60 truncate text-sm font-medium text-gray-700">
        {keyMoment.name}
      </div>
      <div className="flex-1 text-sm">
        Task{" "}
        <span className="mx-1 rounded-md border border-gray-300 bg-gray-50 px-1.5 py-0.5 font-normal text-gray-900">
          {taskTemplate?.title ?? ""}
        </span>{" "}
        status changes to{" "}
        <span className="mx-1 rounded-md border border-green-600/20  bg-green-50 px-1.5 py-0.5 font-normal text-green-700">
          {"Completed"}
        </span>
      </div>
      <div className="w-8">
        <DropdownMenu
          open={optionsOpen}
          onOpenChange={(isOpen) => {
            setOptionsOpen(isOpen);
          }}
        >
          <DropdownMenuTrigger asChild>
            <Button
              variant={"ghost"}
              className={clsx(
                "h-6 w-6 rounded p-0 hover:bg-gray-200/60 group-hover:visible",
                !optionsOpen ? "bg-transparent" : "bg-gray-200/60"
              )}
            >
              <EllipsisHorizontalIcon className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-44" align="end">
            <DropdownMenuGroup>
              {/* <DropdownMenuItem
                // className="py-1 focus:bg-gray-50 focus:text-red-600"
                onClick={(e) => {
                  setIsEditing(true);
                  e.stopPropagation();
                }}
                // className="py-1"
              >
                <Pencil2Icon className="h-3.5 w-3.5 shrink-0" />
                <span className="ml-2 text-sm">Edit</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator /> */}
              <DropdownMenuItem
                // className="py-1 focus:bg-gray-50 focus:text-red-600"
                className="focus:bg-red-50 focus:text-red-600"
                onClick={(e) => {
                  setIsDeleting(true);
                  e.stopPropagation();
                }}
              >
                <TrashIcon className="h-3.5 w-3.5 shrink-0" />
                <span className="ml-2 text-sm">Delete</span>
              </DropdownMenuItem>
              {/* <DropdownMenuItem>Delete</DropdownMenuItem> */}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
        {/* <Dialog open={isEditing} onOpenChange={setIsEditing}>
          <DialogContent
            onPointerDown={(e) => {
              e.stopPropagation();
            }}
          >
            <DialogHeader>
              <DialogTitle>Edit Key Moment Trigger</DialogTitle>
            </DialogHeader>
            <div className="space-y-6 py-4">
              <div className="space-y-1">
                <InputHeading heading="Name" />
                <TextInput
                  className="w-72"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder="Resource name..."
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2">
              <Button variant={"secondary"} onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
              <Button
                disabled={
                  name.trim() === keyMoment.name.trim() || name.trim() === ""
                }
                onClick={() => {
                  updateKeyMomentMutation.mutate({
                    _id: keyMoment._id,
                    name: name,
                  });
                  setIsEditing(false);
                }}
              >
                Save
              </Button>
            </div>
          </DialogContent>
        </Dialog> */}
        <Dialog open={isDeleting} onOpenChange={setIsDeleting}>
          <DialogContent
            onPointerDown={(e) => {
              e.stopPropagation();
            }}
          >
            <DialogHeader>
              <DialogTitle>Delete Key Moment Trigger</DialogTitle>
            </DialogHeader>
            <div className="space-y-6 py-4 text-sm">
              Are you sure you want to delete the key moment trigger for the key
              moment <span className="font-medium">{keyMoment.name}</span>?
            </div>
            <div className="flex justify-end space-x-2">
              <Button
                variant={"secondary"}
                onClick={() => setIsDeleting(false)}
              >
                Cancel
              </Button>
              <Button
                variant={"destructive"}
                onClick={() => {
                  deleteKeyMomentConditionMutation.mutate(
                    keyMoment.condition._id.toString()
                  );
                }}
              >
                {deleteKeyMomentConditionMutation.isLoading
                  ? "Deleting..."
                  : "Delete"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
